var React = require('react');

function IconRefresh (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"currentColor","fill":"none","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M2.1500001,7 C2.61743494,3.89039704 5.42785439,1.5 8.82500005,1.5 C12.0279791,1.5 14.8121689,3.65079093 15.5,6.5","key":0}),React.createElement("polyline",{"points":"5.5 7.5 1.5 7.5 1.5 3.5","key":1}),React.createElement("path",{"d":"M14.815044,10 C14.3441566,13.109603 11.5129788,15.5 8.09074116,15.5 C4.85638673,15.5 2.14997449,13.364867 1.46504407,10.5053783","key":2}),React.createElement("polyline",{"points":"11.5 9.5 15.5 9.5 15.5 13.5","key":3})]));
}

IconRefresh.defaultProps = {"viewBox":"0 0 17 17"};

module.exports = IconRefresh;

IconRefresh.default = IconRefresh;
